import { useState } from "react";
import { motion } from "framer-motion";
import { PlayerSilhouette } from "@/components/PlayerSilhouette";

export function PlayerCard({ player, index = 0 }) {
  const [hover, setHover] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.45, delay: (index % 4) * 0.06 }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="group relative overflow-hidden rounded-xl border border-white/10 bg-royal/40 transition-all duration-300 hover:-translate-y-2"
      style={{ boxShadow: hover ? "0 20px 40px -12px rgba(60,115,192,0.55)" : "none" }}
      data-testid={`player-card-${player.id}`}
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-navy">
        {player.photo ? (
          <img
            src={player.photo}
            alt={player.name}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <PlayerSilhouette className="h-full w-full" />
        )}

        <span
          className="font-display absolute right-3 top-1 text-6xl font-900 leading-none text-gold drop-shadow-lg sm:text-7xl"
          data-testid={`player-number-${player.id}`}
        >
          {player.number}
        </span>

        {/* hover detail overlay */}
        <div
          className={`absolute inset-x-0 bottom-0 bg-gradient-to-t from-navy via-navy/90 to-transparent p-4 transition-all duration-300 ${
            hover ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"
          }`}
        >
          <div className="grid grid-cols-3 gap-1 text-center">
            <div>
              <p className="text-[10px] uppercase tracking-wide text-ice/60">Ηλικία</p>
              <p className="font-display text-lg font-700 text-white">{player.age || "-"}</p>
            </div>
            <div>
              <p className="text-[10px] uppercase tracking-wide text-ice/60">Ύψος</p>
              <p className="font-display text-lg font-700 text-white">{player.height || "-"}</p>
            </div>
            <div>
              <p className="text-[10px] uppercase tracking-wide text-ice/60">Χώρα</p>
              <p className="font-display text-sm font-700 text-white leading-tight pt-1">{player.nationality || "-"}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t-2 border-gold/70 p-4">
        <h4 className="font-heading text-xl font-800 leading-tight tracking-tight text-white">
          {player.name}
        </h4>
        <div className="mt-2 flex flex-wrap gap-x-3 gap-y-1 text-xs text-ice/70 sm:hidden">
          {player.age ? <span>{player.age} ετών</span> : null}
          {player.height ? <span>· {player.height}</span> : null}
          {player.nationality ? <span>· {player.nationality}</span> : null}
        </div>
      </div>
    </motion.div>
  );
}
